import { z } from "zod";

/** `GET /api/v1/salon/public/branches`: one open branch for the picker (FR-SA-244). Mirrors `PublicBranchListItem`. */
export const publicBranchSchema = z.object({
  slug: z.string(),
  name: z.string(),
  city: z.string(),
  addressLine1: z.string(),
  mapUrl: z.string().nullable(),
  phone: z.string(),
});

export const publicBranchListSchema = z.array(publicBranchSchema);

export type PublicBranch = z.infer<typeof publicBranchSchema>;
